module.exports = __webpack_public_path__ + "static/media/upload-icon.c952692b.svg";